import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import ApiService from "../../services/ApiService";
import Loader from "../../components/Loader"; 

const Account = () => {
  const admin= JSON.parse(localStorage.getItem('admin'));

  const [tab, setTab] = useState("email");
  const [email, setEmail] = useState(admin.email);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [enable2FA, setEnable2FA] = useState(false);
  const [loading2FA, setLoading2FA] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  useEffect(() => {
    // Fetch 2FA status on component mount
    const fetch2FAStatus = async () => {
      try {
        const response = await ApiService.request({
          method: "GET",
          url: "admin/get2FAStatus"
        });
        if (response.data.status) {
          setEnable2FA(response.data.data.enable_2fa);
        }
      } catch (error) {
        console.error('Error fetching 2FA status:', error);
      }
    };
    fetch2FAStatus();
  }, []);

  const handleToggle2FA = async () => {
    setLoading2FA(true);
    try {
      const response = await ApiService.request({
        method: "POST",
        url: "admin/toggle2FA"
      });
      const data = response.data;
      if (data.status) {
        setEnable2FA(data.data.enable_2fa);
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error toggling 2FA:', error);
      toast.error('Failed to update 2FA settings');
    } finally {
      setLoading2FA(false);
    }
  };

const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoader(true);
    try {
        const formData = {
            "email": email,
            "old_password": oldPassword,
            "new_password": newPassword,
            "confirm_password": confirmPassword,
          };
        console.log(formData);

        const response = await ApiService.request({
            method: "POST",
            url: "admin/updateAccount",
            data:formData
        });
        const data = response.data;
        if (data.status) {
            admin.email=email;
            console.log(admin);
            localStorage.setItem('admin', JSON.stringify(admin));
            toast.success(data.message);
            setOldPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } else {
            toast.error(data.message);
        }
        setIsLoader(false);
    } catch (error) {
        console.log(error);

        setIsLoader(false);
    }
   
};

  return (
    <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                        Account
                    </h1>
                    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li className="breadcrumb-item text-muted">
                            <a href="/TimeLogger/admin/" className="text-muted text-hover-primary">Home</a>
                        </li>
                        <li className="breadcrumb-item">
                            <span className="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li className="breadcrumb-item text-muted">Account</li>
                    </ul>
                </div>
                <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
            </div>
        </div>

        <div id="kt_app_content" className="app-content flex-column-fluid">
            <div id="kt_app_content_container" className="app-container container-fluid">
                <div className="card">
                    <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <button
                            className={`nav-link fs-lg-5 ${tab === "email" ? "active" : ""}`}
                            onClick={() => setTab("email")}
                            id="nav-profile-tab"
                            type="button"
                        >
                            <i className="bi bi-envelope"></i> Change Email
                        </button>
                        <button
                            className={`nav-link fs-lg-5 ${tab === "password" ? "active" : ""}`}
                            onClick={() => setTab("password")}
                            id="nav-contact-tab"
                            type="button"
                        >
                            <i className="bi bi-key"></i> Change Password
                        </button>
                        <button
                            className={`nav-link fs-lg-5 ${tab === "2fa" ? "active" : ""}`}
                            onClick={() => setTab("2fa")}
                            id="nav-2fa-tab"
                            type="button"
                        >
                            <i className="bi bi-shield-lock"></i> Two-Factor Authentication
                        </button>
                        </div>
                    </nav>
                    <div className="card-body pt-0">
                        <div className="mb-8 text-center"></div>
                        <div className="row g-9 mb-8">
                        <div className="col-md-12">
                            <div className="tab-content mt-5" id="nav-tabContent">
                            {tab === "email" && (
                                <div className="tab-pane fade show active">
                                <form className="form" onSubmit={handleSubmit}>
                                    <div className="d-flex flex-column">
                                    <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                        <span className="required">Email</span>
                                    </label>
                                    <input
                                        type="email"
                                        value={email}
                                        required
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="form-control form-control-solid"
                                        placeholder="Enter Email"
                                    />
                                    </div>
                                    <button
                                    type="submit"
                                    className="btn btn-base my-5"
                                    disabled={isLoader}
                                    >
                                    <span className="indicator-label">
                                        {!isLoader ? "Update Email" : <Loader size="20" text="Updating" />}
                                    </span>
                                    </button>
                                </form>
                                </div>
                            )}
                            {tab === "password" && (
                                <div className="tab-pane fade show active">
                                <form className="form" onSubmit={handleSubmit}>
                                    <div className="row">
                                    <div className="col-md-12">
                                        <label className="required fs-6 fw-semibold mb-2">
                                        Current Password
                                        </label>
                                        <div className="position-relative">
                                            <input
                                            type={showOldPassword ? "text" : "password"}
                                            required
                                            className="form-control form-control-solid"
                                            placeholder="Enter Your Old Password"
                                            value={oldPassword}
                                            onChange={(e) => setOldPassword(e.target.value)}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-link position-absolute end-0 top-50 translate-middle-y"
                                                style={{ border: 'none', background: 'transparent', paddingRight: '10px' }}
                                                onClick={() => setShowOldPassword(!showOldPassword)}
                                            >
                                                <i className={`bi ${showOldPassword ? 'bi-eye-slash' : 'bi-eye'} text-gray-500`}></i>
                                            </button>
                                        </div>
                                        <br />
                                    </div>
                                    <div className="col-md-12 my-3">
                                        <label className="required fs-6 fw-semibold mb-2">
                                        New Password
                                        </label>
                                        <div className="position-relative">
                                            <input
                                            type={showNewPassword ? "text" : "password"}
                                            required
                                            className="form-control form-control-solid"
                                            placeholder="Enter New Password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-link position-absolute end-0 top-50 translate-middle-y"
                                                style={{ border: 'none', background: 'transparent', paddingRight: '10px' }}
                                                onClick={() => setShowNewPassword(!showNewPassword)}
                                            >
                                                <i className={`bi ${showNewPassword ? 'bi-eye-slash' : 'bi-eye'} text-gray-500`}></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-12 my-3">
                                        <label className="required fs-6 fw-semibold mb-2">
                                        Confirm Password
                                        </label>
                                        <div className="position-relative">
                                            <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            required
                                            className="form-control form-control-solid"
                                            placeholder="Enter Confirm Password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-link position-absolute end-0 top-50 translate-middle-y"
                                                style={{ border: 'none', background: 'transparent', paddingRight: '10px' }}
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            >
                                                <i className={`bi ${showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'} text-gray-500`}></i>
                                            </button>
                                        </div>
                                    </div>
                                    </div>
                                    <button
                                    type="submit"
                                    className="btn btn-base my-5"
                                    disabled={isLoader}
                                    >
                                    <span className="indicator-label">
                                        {!isLoader ? "Update Password" : <Loader size="20" text="Updating" />}
                                    </span>
                                    </button>
                                </form>
                                </div>
                            )}
                            {tab === "2fa" && (
                                <div className="tab-pane fade show active">
                                    <div className="d-flex flex-column">
                                        <div className="d-flex align-items-center justify-content-between mb-4">
                                            <div>
                                                <h3 className="fs-4 fw-semibold mb-2">Two-Factor Authentication</h3>
                                                <p className="text-muted">
                                                    Add an extra layer of security to your account by enabling two-factor authentication.
                                                    When enabled, you'll need to verify your identity with a code sent to your email at login.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between p-4 border rounded">
                                            <div>
                                                <h5 className="mb-1">Email Verification</h5>
                                                <p className="text-muted mb-0 small">
                                                    Receive a verification code via email when logging in
                                                </p>
                                            </div>
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="2faToggle"
                                                    checked={enable2FA}
                                                    onChange={handleToggle2FA}
                                                    disabled={loading2FA}
                                                    style={{ width: '3rem', height: '1.5rem', cursor: loading2FA ? 'not-allowed' : 'pointer' }}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="2faToggle">
                                                    {enable2FA ? 'Enabled' : 'Disabled'}
                                                </label>
                                            </div>
                                        </div>
                                        {loading2FA && (
                                            <div className="mt-3">
                                                <Loader size="20" text="Updating..." />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
  );
};

export default Account;
